"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("../../../theme");
var ASPECT_RATIO = {
    '1:1': (1 / 1) * 100,
    '16:9': (9 / 16) * 100,
    '4:3': (3 / 4) * 100,
    '3:2': (2 / 3) * 100,
    '21:9': (9 / 21) * 100,
    '10:16': (16 / 10) * 100,
    '3:1': (1 / 3) * 100,
    '1:1.4142': (1.4142 / 1) * 100,
    '10:1': (1 / 10) * 100,
};
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  border-radius: ", ";\n  overflow: hidden;\n  position: relative;\n  background-color: ", ";\n\n  &:before {\n    content: '';\n    display: block;\n    padding-bottom: ", ";\n  }\n"], ["\n  display: ", ";\n  border-radius: ", ";\n  overflow: hidden;\n  position: relative;\n  background-color: ", ";\n\n  &:before {\n    content: '';\n    display: block;\n    padding-bottom: ", ";\n  }\n"])), function (_a) {
    var _b = _a.$isBlock, $isBlock = _b === void 0 ? true : _b;
    return ($isBlock ? 'block' : 'inline-block');
}, function (_a) {
    var $isRounded = _a.$isRounded;
    return ($isRounded ? '10px' : 0);
}, function (_a) {
    var $backgroundColor = _a.$backgroundColor;
    return $backgroundColor === 'transparent'
        ? 'transparent'
        : $backgroundColor
            ? theme_1.theme.colors[$backgroundColor]
            : theme_1.theme.colors.GREY_10;
}, function (_a) {
    var $aspectRatio = _a.$aspectRatio;
    return ($aspectRatio ? "".concat(ASPECT_RATIO[$aspectRatio], "%") : 0);
});
var templateObject_1;
